import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';

import { SLOW_DATA } from '../constants';

const stationTimeOffset = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_STATION_NAMES:
      return null;
    case actionTypes.SET_STATION_TIME_OFFSET:
      return action.stationTimeOffset;
    default:
      return state;
  }
}

const startDate = (state = new Date(), action) => {
  switch (action.type) {
    case actionTypes.SET_START_DATE:
      return action.date;
    default:
      return state;
  }
}

const endDate = (state = new Date(), action) => {
  switch (action.type) {
    case actionTypes.SET_END_DATE:
      return action.date;
    default:
      return state;
  }
}

const dataType = (state = SLOW_DATA, action) => {
  switch (action.type) {
    default:
      return state;
  }
}

const years = (state = [], action) => {
  switch (action.type) {
    case actionTypes.LOAD_YEARS_SUCCESS:
      return action.years;
    default:
      return state;
  }
}

const stationTimeData = (state = [], action) => {
  switch (action.type) {
    case actionTypes.LOAD_SELECTED_STATION_TIME_SUCCESS:
      return action.stationTimeData;
    default:
      return state;
  }
}

const findStationFields = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_FIND_STATIONS_FIELDS_SUCCESS:
      return action.findStationFields;
    default:
      return state;
  }
}

const selectedStationName = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_STATION_NAMES:
      return action.stationName;
    default:
      return state;
  }
}

const openedSnackBar = (state = false, action) => {
  switch (action.type) {
    case actionTypes.OPEN_SNACK_BAR:
      return true;
    case actionTypes.CLOSE_SNACK_BAR:
      return false;
    default:
      return state;
  }
}

const snackBarMessage = (state = "", action) => {
  switch (action.type) {
    case actionTypes.OPEN_SNACK_BAR:
      return action.message;
    case actionTypes.CLOSE_SNACK_BAR:
      return "";
    default:
      return state;
  }
}

const openedAlertDialog = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CREATE_DOWNLOAD_REQUEST_SUCCESS:
      return true;
    case actionTypes.CLOSE_ALERT_DIALOG:
      return false;
    default:
      return state;
  }
}

const openStationsFieldDialog = (state = false, action) => {
  switch(action.type){
    case actionTypes.TOGGLE_STATIONS_FIELDS_DIALOG:
      return !state;
    default:
      return state;
  }
}

export default combineReducers({
  startDate,
  endDate,
  dataType,
  years,
  stationTimeData,
  findStationFields,
  selectedStationName,
  openedSnackBar,
  snackBarMessage,
  openedAlertDialog,
  stationTimeOffset,
  openStationsFieldDialog
});

const getCurrentState = state => state.downloadRequests.downloadForm;

export const getStartDate = state => getCurrentState(state).startDate;

export const getEndDate = state => getCurrentState(state).endDate;

export const getDataType = state => getCurrentState(state).dataType;

export const getYears = state => getCurrentState(state).years;

export const getSelectedStationTime = state => getCurrentState(state).stationTimeData;

export const getFindStationFields = state => getCurrentState(state).findStationFields;

export const getSelectedStationName = state => getCurrentState(state).selectedStationName

export const getOpenedSnackBar = state => getCurrentState(state).openedSnackBar;

export const getSnackBarMessage = state => getCurrentState(state).snackBarMessage;

export const getOpenedAlertDialog = state => getCurrentState(state).openedAlertDialog;

export const getStationTimeOffset = state => getCurrentState(state).stationTimeOffset;

export const getOpenStationsFieldDialog = state => getCurrentState(state).openStationsFieldDialog

export const getIsFormValid = state => {
  const { stationTimeOffset, selectedStationName } = getCurrentState(state);
  return stationTimeOffset && selectedStationName;
} 